import { useState, useEffect } from 'react';

/**
 * True when the app is running as an installed PWA (standalone or minimal-ui),
 * i.e. without browser chrome (no address bar, back/refresh).
 */
export function useIsStandalone() {
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    const check = () => {
      const standaloneMedia = window.matchMedia('(display-mode: standalone)');
      const hasStandalone = standaloneMedia.matches;
      const hasMinimalUi = window.matchMedia('(display-mode: minimal-ui)').matches;
      const isIosStandalone = !!window.navigator.standalone;
      setStandalone(hasStandalone || hasMinimalUi || isIosStandalone);
    };
    check();
    const mql = window.matchMedia('(display-mode: standalone)');
    const listener = () => check();
    mql.addEventListener('change', listener);
    return () => mql.removeEventListener('change', listener);
  }, []);

  return standalone;
}
